import styled, { Scale } from '@secretescapes/falcon';

export const Container = styled('div')`
  flex-grow: 1;
  position: relative;

  > div {
    padding: ${Scale.s} ${Scale.m};
  }

  ul {
    width: 100%;
    box-sizing: border-box;
    top: unset;
    padding: ${Scale.m};
  }
`;
